export function TextEditorBold() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.6 11.79C16.57 11.12 17.25 10.02 17.25 9C17.25 6.74 15.5 5 13.25 5H7V19H14.04C16.13 19 17.75 17.3 17.75 15.21C17.75 13.69 16.89 12.39 15.6 11.79ZM10 7.5H13C13.83 7.5 14.5 8.17 14.5 9C14.5 9.83 13.83 10.5 13 10.5H10V7.5ZM13.5 16.5H10V13.5H13.5C14.33 13.5 15 14.17 15 15C15 15.83 14.33 16.5 13.5 16.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function TextEditorBulletList() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 10.5C3.17 10.5 2.5 11.17 2.5 12C2.5 12.83 3.17 13.5 4 13.5C4.83 13.5 5.5 12.83 5.5 12C5.5 11.17 4.83 10.5 4 10.5ZM4 4.5C3.17 4.5 2.5 5.17 2.5 6C2.5 6.83 3.17 7.5 4 7.5C4.83 7.5 5.5 6.83 5.5 6C5.5 5.17 4.83 4.5 4 4.5ZM4 16.67C3.26 16.67 2.67 17.27 2.67 18C2.67 18.73 3.27 19.33 4 19.33C4.73 19.33 5.33 18.73 5.33 18C5.33 17.27 4.74 16.67 4 16.67ZM7 19H21V17H7V19ZM7 13H21V11H7V13ZM7 5V7H21V5H7Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function TextEditorHeading() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 4V7H14V19H17V7H22V4H9ZM3 12H6V19H9V12H12V9H3V12Z" fill="currentColor" />
    </svg>
  );
}

export function TextEditorItalic() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 5V8H12.21L8.79 16H6V19H14V16H11.79L15.21 8H18V5H10Z" fill="currentColor" />
    </svg>
  );
}

export function TextEditorNumberedList() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 17H4V17.5H3V18.5H4V19H2V20H5V16H2V17ZM3 8H4V4H2V5H3V8ZM2 11H3.8L2 13.1V14H5V13H3.2L5 10.9V10H2V11ZM7 5V7H21V5H7ZM7 19H21V17H7V19ZM7 13H21V11H7V13Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function TextEditorPlaceholder() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 20V16H5V19H8V21H4C3.44772 21 3 20.5523 3 20Z" fill="currentColor" />
      <path d="M5 5V8H3V4C3 3.44772 3.44772 3 4 3H8V5H5Z" fill="currentColor" />
      <path d="M16 5V3H20C20.5523 3 21 3.44772 21 4V8H19V5H16Z" fill="currentColor" />
      <path d="M19 19V16H21V20C21 20.5523 20.5523 21 20 21H16V19H19Z" fill="currentColor" />
      <path
        d="M17 12C17 12.5523 16.5523 13 16 13H13.0005V16C13.0005 16.5523 12.5527 17 12.0005 17C11.4482 17 11.0005 16.5523 11.0005 16V13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H11.0005L11.0005 8C11.0005 7.44772 11.4482 7 12.0005 7C12.5527 7 13.0005 7.44772 13.0005 8V11H16C16.5523 11 17 11.4477 17 12Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function TextEditorUnderline() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 16C15.31 16 18 13.31 18 10V4H15.5V10C15.5 11.93 13.93 13.5 12 13.5C10.07 13.5 8.5 11.93 8.5 10V4H6V10C6 13.31 8.69 16 12 16ZM5 18V20H19V18H5Z"
        fill="currentColor"
      />
    </svg>
  );
}
